<template>
    <student-backend-layout>
        <div class="mb-12">
            <h2 class="h3">Your Subscription</h2>
            <hr class="mb-8 border-neutral-20" />

            <div>
                <div class="w-full">
                    <div class="flex">
                        <div v-if="subscription">
                            <div class="mb-8">
                                <div
                                    class="flex items-start text-[24px] font-semibold"
                                >
                                    {{ subscription.plan.title }}
                                    <span
                                        class="label-primary ml-4 rounded bg-gray-400 p-1 px-2 text-[14px] text-white"
                                        >{{
                                            subscription.plan.renews
                                                ? "Auto-Renewal"
                                                : ""
                                        }}</span
                                    >
                                </div>
                                <div
                                    v-if="!isGroupMember"
                                    class="text-[18px] font-semibold text-neutral-60"
                                >
                                    <value-as-currency
                                        :value="subscription.plan.price_usd"
                                    />
                                    /
                                    <span class="capitalize">{{
                                        subscription.plan.period_label_singular
                                    }}</span>
                                </div>
                                <div
                                    v-else
                                    class="text-[18px] font-semibold text-neutral-60"
                                >
                                    Group Membership
                                </div>
                                <div
                                    class="text-[18px] font-semibold text-neutral-60"
                                >
                                    {{ subscription.plan.description }}
                                </div>
                            </div>
                            <div
                                v-if="subscription.stripe_subscription_id"
                                class="font-18"
                            >
                                <div class="flex">
                                    <div class="">
                                        <div
                                            v-if="!subscription.is_active"
                                            class="font-semibold"
                                        >
                                            <div class="text-neutral-60">
                                                Your subscription
                                                <span
                                                    class="font-semibold text-danger-darker"
                                                    >expired</span
                                                >
                                                on
                                                <span
                                                    class="font-semibold text-neutral-100"
                                                    >{{
                                                        dayjs(
                                                            subscription.ends_at
                                                        )
                                                            .utc(true)
                                                            .tz(
                                                                $page.props.auth
                                                                    .user
                                                                    .timezone
                                                            )
                                                            .format(
                                                                $page.props
                                                                    .date_formats
                                                                    .short
                                                            )
                                                    }}</span
                                                >
                                            </div>
                                            <div class="mt-4">
                                                <no-subscription-modal
                                                    :start-open="false"
                                                    button-text="Restart Subscription"
                                                ></no-subscription-modal>
                                            </div>
                                        </div>
                                        <div
                                            v-else-if="subscription.renews_at"
                                            class="font-semibold"
                                        >
                                            <div class="text-neutral-60">
                                                Your subscription will
                                                <span
                                                    class="rounded bg-success-lighter p-1 font-semibold text-success-darker"
                                                    >renew</span
                                                >
                                                on
                                                <span
                                                    class="font-semibold text-neutral-100"
                                                    >{{
                                                        dayjs(
                                                            subscription.renews_at
                                                        )
                                                            .utc(true)
                                                            .tz(
                                                                $page.props.auth
                                                                    .user
                                                                    .timezone
                                                            )
                                                            .format(
                                                                $page.props
                                                                    .date_formats
                                                                    .short
                                                            )
                                                    }}</span
                                                >
                                            </div>
                                            <div
                                                class="max-w-sm py-4 text-[16px] font-light text-gray-600"
                                            >
                                                Cancel before this date to
                                                ensure you are not charged. Your
                                                account will remain active until
                                                the end of your billing cycle.
                                            </div>
                                            <span
                                                class="btn btn-primary btn-sm mt-2 inline-block"
                                                @click="toggleAutoRenew()"
                                                >Turn off Auto-Renew</span
                                            >
                                        </div>
                                        <div v-else class="font-semibold">
                                            <div class="text-neutral-60">
                                                Your subscription will
                                                <span
                                                    class="rounded bg-danger-lighter p-1 font-semibold text-danger-darker"
                                                    >expire</span
                                                >
                                                on
                                                <span
                                                    class="font-semibold text-neutral-100"
                                                    >{{
                                                        dayjs(
                                                            subscription.ends_at
                                                        )
                                                            .utc(true)
                                                            .tz(
                                                                $page.props.auth
                                                                    .user
                                                                    .timezone
                                                            )
                                                            .format(
                                                                $page.props
                                                                    .date_formats
                                                                    .short
                                                            )
                                                    }}</span
                                                >
                                            </div>
                                            <span
                                                v-if="paymentMethodSet"
                                                class="btn btn-success btn-sm mt-2 inline-block"
                                                @click="toggleAutoRenew()"
                                                >Restart Membership</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="flex">
                                    <div v-if="!subscription.is_active">
                                        <div class="font-semibold">
                                            <div class="pb-4 text-neutral-60">
                                                Your subscription
                                                <span
                                                    class="rounded bg-danger-lighter p-1 font-semibold text-danger-darker"
                                                    >expired</span
                                                >
                                                on
                                                <span
                                                    class="font-semibold text-neutral-100"
                                                    >{{
                                                        dayjs(
                                                            subscription.ends_at
                                                        )
                                                            .utc(true)
                                                            .tz(
                                                                $page.props.auth
                                                                    .user
                                                                    .timezone
                                                            )
                                                            .format(
                                                                $page.props
                                                                    .date_formats
                                                                    .full
                                                            )
                                                    }}</span
                                                >
                                            </div>
                                            <no-subscription-modal
                                                :start-open="true"
                                                button-text="Restart Subscription"
                                            ></no-subscription-modal>
                                        </div>
                                    </div>
                                    <div v-else class="">
                                        <div class="font-semibold">
                                            <div class="text-neutral-60">
                                                Your subscription will
                                                <span
                                                    class="rounded bg-danger-lighter p-1 font-semibold text-danger-darker"
                                                    >expire</span
                                                >
                                                on
                                                <span
                                                    class="font-semibold text-neutral-100"
                                                    >{{
                                                        dayjs(
                                                            subscription.ends_at
                                                        )
                                                            .utc(true)
                                                            .tz(
                                                                $page.props.auth
                                                                    .user
                                                                    .timezone
                                                            )
                                                            .format(
                                                                $page.props
                                                                    .date_formats
                                                                    .full
                                                            )
                                                    }}</span
                                                >
                                            </div>
                                            <div v-if="paymentMethodSet">
                                                <span
                                                    class="btn btn-success btn-sm mt-2 inline-block"
                                                    @click="toggleAutoRenew()"
                                                    >Restart Membership</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <no-subscription-modal
                                :start-open="true"
                                button-text="Start Subscription"
                            ></no-subscription-modal>
                        </div>
                    </div>
                </div>
            </div>
            <user-payment-method
                v-if="!$page.props.auth.user.group_id"
            ></user-payment-method>
        </div>
    </student-backend-layout>
</template>

<script>
import StudentBackendLayout from "@/_Layouts/NewStudentBackendLayout.vue";
import UserPaymentMethod from "@/Components/UserPaymentMethod.vue";
import NoSubscriptionModal from "@/Components/NoSubscriptionModal.vue";
import ValueAsCurrency from "@/Components/ValueAsCurrency.vue";

export default {
    name: "StudentManageSubscription",
    components: {
        ValueAsCurrency,
        StudentBackendLayout,
        UserPaymentMethod,
        NoSubscriptionModal,
    },
    props: {
        subscription: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            isGroupMember: !!this.$page.props.auth.user.group_id,
            paymentMethodSet: this.$page.props.auth.user.stripe_card_meta
                ? true
                : false,
        };
    },
    methods: {
        toggleAutoRenew: function () {
            this.$inertia.post("/student/toggle-auto-renew");
        },
    },
};
</script>
